import { render, staticRenderFns } from "./Concerning.vue?vue&type=template&id=8c4466e8&scoped=true"
import script from "./Concerning.vue?vue&type=script&lang=js"
export * from "./Concerning.vue?vue&type=script&lang=js"
import style0 from "./Concerning.vue?vue&type=style&index=0&id=8c4466e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4466e8",
  null
  
)

export default component.exports